import { Component, OnInit, Input } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';

@Component({
  selector: 'app-slider-range',
  templateUrl: './slider-range.component.html',
  styleUrls: ['./slider-range.component.css']
})
export class SliderRangeComponent implements OnInit {

  constructor() { }

  ngOnInit() {

  }
}